export default __webpack_public_path__ + "static/media/file_type_xls.3acf7266.svg";